import { adminDownloadLogVehicleExcel } from "helpers/backend_helpers";
import moment from "moment";
import { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";

const DownloadModalLogVehicle = ({ show, onCloseClick }: any) => {
  const [filterDate, setFilterDate] = useState<any>([]);
  const [filterDateOut, setFilterDateOut] = useState<any>([]);
  const [filterCategory, setFilterCategory] = useState<any>(null);
  const [filterCategoryOwner, setFilterCategoryOwner] = useState<any>(null);
  const [filterLicenseNumber, setFilterLicenseNumber] = useState<string>("");
  const [flatpickrKey, setFlatpickrKey] = useState(0);
  const [flatpickrKeyOut, setFlatpickrKeyOut] = useState(0);
  const [downloadType, setDownloadType] = useState<string>("all");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const comboCategory = [
    { value: "MOTOR", label: "MOTOR" },
    { value: "MOBIL", label: "MOBIL" },
    { value: "TRUK", label: "TRUK" },
  ];

  const comboCategoryOwner = [
    { value: "TAMU", label: "TAMU" },
    { value: "KARYAWAN", label: "KARYAWAN" },
    { value: "VENDOR", label: "VENDOR" },
  ];

  const handleDownloadTypeChange = (type: string) => {
    setDownloadType(type);
    if (type === "all") {
      setFilterDate([]);
      setFilterDateOut([]);
      setFilterCategory(null);
      setFilterCategoryOwner(null);
      setFilterLicenseNumber("");
      setFlatpickrKey((prev) => prev + 1);
      setFlatpickrKeyOut((prev) => prev + 1);
    }
  };

  const downloadData = async () => {
    if (downloadType === "specific") {
      const hasInDateFilter = filterDate[0] && filterDate[1];
      const hasOutDateFilter = filterDateOut[0] && filterDateOut[1];
      const hasLicenseFilter = filterLicenseNumber.trim() !== "";
      const hasCategoryFilter = filterCategory !== null;
      const hasCategoryOwnerFilter = filterCategoryOwner !== null;

      if (
        !hasInDateFilter &&
        !hasOutDateFilter &&
        !hasLicenseFilter &&
        !hasCategoryFilter &&
        !hasCategoryOwnerFilter
      ) {
        toast.error("Pilih minimal satu filter untuk download data tertentu!");
        return;
      }
    }

    setIsLoading(true);
    try {
      let query: any = {};

      if (downloadType === "specific") {
        if (filterDate[0] && filterDate[1]) {
          query.startInDate = moment(filterDate[0]).format(
            "YYYY-MM-DDTHH:mm:ss",
          );
          query.endInDate = moment(filterDate[1]).format("YYYY-MM-DDTHH:mm:ss");
        }
        if (filterDateOut[0] && filterDateOut[1]) {
          query.startOutDate = moment(filterDateOut[0]).format(
            "YYYY-MM-DDTHH:mm:ss",
          );
          query.endOutDate = moment(filterDateOut[1]).format(
            "YYYY-MM-DDTHH:mm:ss",
          );
        }
        if (filterLicenseNumber.trim()) {
          query.licenseNumber = filterLicenseNumber.trim();
        }
        if (filterCategory) {
          query.category = filterCategory.value;
        }
        if (filterCategoryOwner) {
          query.categoryOwner = filterCategoryOwner.value;
        }
      }

      const response: any = await adminDownloadLogVehicleExcel(query);

      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Buku Catatan Kendaraan.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success("Unduh data buku catatan kendaraan berhasil");
      onCloseClick();
    } catch (error) {
      toast.error("Gagal mengunduh data.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!show) {
      setFilterDate([]);
      setFilterDateOut([]);
      setFilterCategory(null);
      setFilterCategoryOwner(null);
      setFilterLicenseNumber("");
      setDownloadType("all");
      setFlatpickrKey((prev) => prev + 1);
      setFlatpickrKeyOut((prev) => prev + 1);
      setIsLoading(false);
    }
  }, [show]);

  return (
    <Modal
      fade={true}
      isOpen={show}
      toggle={onCloseClick}
      centered={true}
      size="md"
    >
      <ModalHeader
        className="bg-gradient-to-r from-blue-50 to-indigo-50 border-0 p-4"
        toggle={onCloseClick}
      >
        <div className="d-flex align-items-center">
          <div>
            <h5 className="mb-0 text-dark fw-semibold">
              Unduh Data Buku Catatan Kendaraan
            </h5>
          </div>
        </div>
      </ModalHeader>

      <ModalBody className="p-4">
        <div className="mb-4">
          <Label className="form-label text-dark fw-semibold mb-3">
            Pilih Tipe Unduhan
          </Label>
          <div className="d-flex gap-3">
            <div
              className={`flex-fill border rounded-3 p-3 transition-all ${
                downloadType === "all"
                  ? "border-primary bg-primary bg-opacity-10"
                  : "border-secondary border-opacity-25"
              }`}
              onClick={() => handleDownloadTypeChange("all")}
              style={{ cursor: "pointer" }}
            >
              <div className="form-check mb-0">
                <Input
                  className="form-check-input"
                  type="radio"
                  name="downloadType"
                  id="downloadAll"
                  checked={downloadType === "all"}
                  onChange={() => handleDownloadTypeChange("all")}
                />
                <Label
                  className="form-check-label d-flex align-items-center"
                  htmlFor="downloadAll"
                  style={{ cursor: "pointer" }}
                >
                  <i className="ri-folder-download-line me-2 fs-5"></i>
                  <div>
                    <div className="fw-semibold">Semua Data</div>
                    <small className="text-muted">
                      Download semua data kendaraan
                    </small>
                  </div>
                </Label>
              </div>
            </div>

            <div
              className={`flex-fill border rounded-3 p-3 transition-all ${
                downloadType === "specific"
                  ? "border-primary bg-primary bg-opacity-10"
                  : "border-secondary border-opacity-25"
              }`}
              onClick={() => handleDownloadTypeChange("specific")}
              style={{ cursor: "pointer" }}
            >
              <div className="form-check mb-0">
                <Input
                  className="form-check-input"
                  type="radio"
                  name="downloadType"
                  id="downloadSpecific"
                  checked={downloadType === "specific"}
                  onChange={() => handleDownloadTypeChange("specific")}
                />
                <Label
                  className="form-check-label d-flex align-items-center"
                  htmlFor="downloadSpecific"
                  style={{ cursor: "pointer" }}
                >
                  <i className="ri-filter-3-line me-2 fs-5"></i>
                  <div>
                    <div className="fw-semibold">Data Tertentu</div>
                    <small className="text-muted">Filter data kendaraan</small>
                  </div>
                </Label>
              </div>
            </div>
          </div>
        </div>

        {downloadType === "specific" && (
          <div className="animate-fade-in">
            <div className="border-top pt-4 mt-2">
              <Label className="form-label text-dark fw-semibold mb-3">
                <i className="ri-filter-line me-2"></i>
                Filter Data
              </Label>

              <div className="mb-3">
                <Label className="form-label text-muted small mb-2">
                  <i className="ri-calendar-line me-1"></i>
                  Rentang Tanggal & Waktu Masuk
                </Label>
                <Flatpickr
                  key={flatpickrKey}
                  className="form-control shadow-sm"
                  options={{
                    mode: "range",
                    dateFormat: "Y-m-d H:i",
                    enableTime: true,
                    time_24hr: true,
                  }}
                  onChange={(e) => setFilterDate(e)}
                  value={filterDate}
                  placeholder="Pilih rentang tanggal & waktu masuk"
                />
              </div>

              <div className="mb-3">
                <Label className="form-label text-muted small mb-2">
                  <i className="ri-calendar-check-line me-1"></i>
                  Rentang Tanggal & Waktu Keluar
                </Label>
                <Flatpickr
                  key={flatpickrKeyOut}
                  className="form-control shadow-sm"
                  options={{
                    mode: "range",
                    dateFormat: "Y-m-d H:i",
                    enableTime: true,
                    time_24hr: true,
                  }}
                  onChange={(e) => setFilterDateOut(e)}
                  value={filterDateOut}
                  placeholder="Pilih rentang tanggal & waktu keluar"
                />
              </div>

              <div className="mb-3">
                <Label className="form-label text-muted small mb-2">
                  <i className="ri-car-line me-1"></i>
                  Plat Nomor
                </Label>
                <Input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Cari plat nomor..."
                  value={filterLicenseNumber}
                  onChange={(e) => setFilterLicenseNumber(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <Label className="form-label text-muted small mb-2">
                  <i className="ri-truck-line me-1"></i>
                  Kategori Kendaraan
                </Label>
                <Select
                  value={filterCategory}
                  onChange={(e: any) => setFilterCategory(e)}
                  options={comboCategory}
                  className="basic-multi-select shadow-sm"
                  classNamePrefix="select"
                  placeholder="Pilih Kategori Kendaraan"
                  isClearable
                />
              </div>

              <div className="mb-3">
                <Label className="form-label text-muted small mb-2">
                  <i className="ri-user-line me-1"></i>
                  Kategori Pemilik Kendaraan
                </Label>
                <Select
                  value={filterCategoryOwner}
                  onChange={(e: any) => setFilterCategoryOwner(e)}
                  options={comboCategoryOwner}
                  className="basic-multi-select shadow-sm"
                  classNamePrefix="select"
                  placeholder="Pilih Kategori Pemilik Kendaraan"
                  isClearable
                />
              </div>
            </div>
          </div>
        )}
      </ModalBody>

      <ModalFooter className="bg-light border-0 p-4">
        <button
          type="button"
          className="btn btn-light border shadow-sm px-4 btn-sm"
          onClick={onCloseClick}
          disabled={isLoading}
        >
          <i className="ri-close-line me-1"></i>
          Batal
        </button>
        <button
          type="button"
          className="btn btn-primary shadow-sm px-4 btn-sm"
          onClick={downloadData}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <Spinner size="sm" className="me-2" />
              Mengunduh...
            </>
          ) : (
            <>
              <i className="ri-download-2-line me-1"></i>
              Unduh Data
            </>
          )}
        </button>
      </ModalFooter>

      <style>{`
        .animate-fade-in {
          animation: fadeIn 0.3s ease-in;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .transition-all {
          transition: all 0.2s ease-in-out;
        }

        .bg-opacity-10 {
          --bs-bg-opacity: 0.1;
        }

        .border-opacity-25 {
          --bs-border-opacity: 0.25;
        }
      `}</style>
    </Modal>
  );
};

export default DownloadModalLogVehicle;
